export default __webpack_public_path__ + "static/media/611.79de92a8.png";